import { INITIAL_VERSION } from "@hireroo/app-definition/question";
import * as ErrorHandlingHelper from "@hireroo/app-helper/error-handling";
import { RemotesId } from "@hireroo/app-store/page/e/remotes_id";
import { Snackbar } from "@hireroo/app-store/widget/shared/Snackbar";
import { getGraphqlClient } from "@hireroo/graphql/client/request";
import * as Graphql from "@hireroo/graphql/client/urql";
import { getTranslation } from "@hireroo/i18n";
import * as Sentry from "@sentry/browser";

export const startSubscribeActiveSessionsForHideQuestions = () => {
  return RemotesId.subscribeActiveSessionMap(activeSessions => {
    activeSessions.forEach(activeSession => {
      if (activeSession.systemDesignQuestion?.questionId) {
        const version = INITIAL_VERSION;
        const questionId = activeSession.systemDesignQuestion.questionId;
        const key: RemotesId.QuestionsTableStore.QuestionUniqueKey = `${Graphql.LiveCodingQuestionType.SystemDesign}-${questionId}-${version}`;
        RemotesId.QuestionsTableStore.hideQuestion(key);
      } else if (activeSession.algorithmQuestion?.questionId) {
        const version = activeSession.algorithmQuestion.version;
        const questionId = activeSession.algorithmQuestion.questionId;
        const key: RemotesId.QuestionsTableStore.QuestionUniqueKey = `${Graphql.LiveCodingQuestionType.Algorithm}-${questionId}-${version}`;
        RemotesId.QuestionsTableStore.hideQuestion(key);
      }
    });
  });
};

export const startSubscribeActiveSessionsForUpdateTemplateCodes = () => {
  return RemotesId.subscribeActiveSessionMap(activeSessions => {
    const client = getGraphqlClient();
    const { t } = getTranslation();
    const algorithmQuestions = activeSessions.map(session => session.algorithmQuestion).flatMap(v => (v ? [v] : []));

    const liveCodingTemplateCodesMap = RemotesId.getLiveCodingTemplateCodesMap();
    const algorithmQuestionsNotGettingTemplateCodes = algorithmQuestions.filter(algorithmQuestion => {
      const key: RemotesId.LiveCodingTemplateCodesMapKey = `${algorithmQuestion.questionId}-${algorithmQuestion.version}`;
      return !liveCodingTemplateCodesMap.has(key);
    });

    const tasks = algorithmQuestionsNotGettingTemplateCodes.map(algorithmQuestion => {
      const key: RemotesId.LiveCodingTemplateCodesMapKey = `${algorithmQuestion.questionId}-${algorithmQuestion.version}`;
      client
        .GetLiveCodingTemplateCodes({
          questionId: algorithmQuestion.questionId,
          questionVersion: algorithmQuestion.version,
        })
        .then(res => {
          RemotesId.addLiveCodingTemplateCodes(key, res.liveCodingTemplateCodes);
        })
        .catch(error => {
          Sentry.captureException(error);
          const errorNotification = ErrorHandlingHelper.generateErrorNotification(error, t("コードテンプレートの取得に失敗しました。"));
          Snackbar.notify({
            severity: "error",
            message: errorNotification.message,
          });
        });
    });

    Promise.all(tasks);
  });
};
